import { useEffect, useRef } from 'react';

type TranslationConfig = {
  configuration?: {
    dateFormat?: string;
  };
};

type TranslationActions = {
  setTranslationDateFormat: (format?: string) => void;
  translateDateFormat: (current: string, previous: string) => void;
};

export const useTranslationConfigSync = (
  translationConfigFetched: boolean,
  translationConfig: TranslationConfig,
  actions: TranslationActions,
  previousDateFormat: string
) => {
  const hasInitialized = useRef(false);
  const lastDateFormat = useRef<string | undefined>();

  useEffect(() => {
    if (translationConfigFetched && translationConfig?.configuration?.dateFormat) {
      const newDateFormat = translationConfig.configuration.dateFormat;
      
      // Only update if this is the first time or if the date format actually changed
      if (!hasInitialized.current || lastDateFormat.current !== newDateFormat) {
        hasInitialized.current = true;
        lastDateFormat.current = newDateFormat;
        
        actions.setTranslationDateFormat(newDateFormat);
        
        // Only translate if we have a previous format and it's different
        if (previousDateFormat && previousDateFormat !== newDateFormat) {
          actions.translateDateFormat(newDateFormat, previousDateFormat);
        }
      }
    }
  }, [translationConfigFetched, translationConfig, actions]);
};
